// /**
//  * Create Bundle List
//  */

// React
import React, { useContext, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

// Context
import AuthContext from '../../authContext';

// UI
import theme from '../../theme';
import clsx from 'clsx';
import {
  createStyles,
  makeStyles,
  Theme,
  withStyles,
  lighten,
} from '@material-ui/core/styles';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Paper,
  IconButton,
  Button,
  Checkbox,
  Typography,
  Tooltip,
  Toolbar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiFileDocumentOutline,
  mdiHistory,
  mdiChevronDown,
  mdiChevronUp,
} from '@mdi/js';

// Helper
import { checkMatchMedia, translate } from '../../utils/helpers';
import jMoment from 'moment-jalaali';

// Type
import { Order, NonPostOrder } from '../orders/interfaces';

type Data = NonPostOrder;
type Props = {
  data: any;
  loading: boolean;
  handleSelectedList: (selected: Order[]) => void;
  handleSelectAllClick: (event: any) => void;
};
type Ord = 'asc' | 'desc';

interface HeadCell {
  id: keyof Data;
  label: string;
}

interface EnhancedTableProps {
  classes: ReturnType<typeof useStyles>;
  onRequestSort: (
    event: React.MouseEvent<unknown>,
    property: keyof Data
  ) => void;
  order: Ord;
  orderBy: string;
  rowCount: number;
  numSelected: number;
}

// Style
const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      '@media (max-width: 768px)': {
        fontSize: 10,
      },
    },
    body: {
      fontSize: 14,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  })
)(TableCell);
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
    },
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    paper: {
      width: '100%',
    },
    table: {
      // minWidth: 750,
    },
    head: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
    },
    columnText: {
      padding: '0 10px',
    },
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1,
    },
    container: {
      maxHeight: 650,
      borderRadius: '4px',
    },
    // Fully visible for active icons
    activeSortIcon: {
      opacity: 1,
      color: `${theme.palette.secondary.main}!important`,
    },
    // Half visible for inactive icons
    inactiveSortIcon: {
      opacity: 0.4,
    },
    iconButton: {
      padding: 10,
      position: 'relative',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '36px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    changStatusIcon: {
      marginRight: '10px',
      position: 'absolute',
    },
    changStatusBox: {
      display: 'flex',
      textAlign: 'left',

      fontWeight: 400,
      fontSize: '14px',
    },
    renderValue: {
      paddingLeft: '32px',
    },
    radioGroup: {
      margin: '-8px 0',
    },
    radioGroupItem: {
      borderBottom: '1px solid #D8D8D8',
      marginRight: '-8px',
      padding: '8px 16px',
      '&:last-child': {
        borderBottom: '0px',
      },
    },
  })
);

const useToolbarStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(1),
      marginBottom: theme.spacing(1),
      justifyContent: 'space-between',
    },
    highlight:
      theme.palette.type === 'light'
        ? {
          color: theme.palette.success.main,
          backgroundColor: lighten(theme.palette.success.light, 0.85),
        }
        : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.success.dark,
        },
    title: {
      // flex: '1 1 100%',
    },
  })
);

interface EnhancedTableToolbarProps {
  numSelected: number;
  selected: any;
  data: any;
  handleSelectedList: (selected: Order[]) => void;
}

const EnhancedTableToolbar = (props: EnhancedTableToolbarProps) => {
  const classes = useToolbarStyles();
  const [openAlertWarning, setOpenAlertWarning] = useState(false as boolean);
  const { numSelected, selected, data } = props;

  const checkStatus = (data: any) => {
    let sameStatus = true;
    data?.map((item: any) => {
      if (item?.status !== data[0]?.status) {
        return (sameStatus = false);
      }
      return item;
    });
    return sameStatus;
  };

  return (
    <>
      {numSelected > 0 && (
        <Toolbar
          className={clsx(classes.root, {
            [classes.highlight]: numSelected > 0,
          })}
        >
          {numSelected > 0 ? (
            <Typography
              className={classes.title}
              color="inherit"
              variant="subtitle1"
              component="div"
            >
              {numSelected} انتخاب
            </Typography>
          ) : (
            <Typography
              className={classes.title}
              variant="h6"
              id="tableTitle"
              component="div"
            />
          )}
          {numSelected > 0 ? (
            <Tooltip title="تخصیص اپراتور">
              <Button
                size="small"
                variant="contained"
                onClick={() => props.handleSelectedList(selected)}
                color="secondary"
              >
                انتخاب ترتیب ارسال
              </Button>
            </Tooltip>
          ) : (
            <></>
            // <Tooltip title="Filter list">
            //   <IconButton aria-label="filter list">
            //     FilterIcon
            //   </IconButton>
            // </Tooltip>
          )}
        </Toolbar>
      )}
      <Dialog
        fullWidth
        open={openAlertWarning}
        onClose={() => setOpenAlertWarning(false)}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>امکان تغییر وضعیت سفارش وجود ندارد </DialogTitle>
        <DialogContent>
          وضعیت سفارش آیتم‌های انتخاب شده باید یکی باشد
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={() => setOpenAlertWarning(false)}
            variant="contained"
            color="primary"
          >
            {'متوجه شدم'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator<Key extends keyof any>(
  order: Ord,
  orderBy: Key
): (
    a: { [key in Key]: number | string },
    b: { [key in Key]: number | string }
  ) => number {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort<T>(array: T[], comparator: (a: T, b: T) => number) {
  const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

function EnhancedTableHead(props: EnhancedTableProps) {
  const classes = useStyles();
  const { order, orderBy, onRequestSort, numSelected, rowCount } = props;
  const createSortHandler = (property: keyof Data) => (
    event: React.MouseEvent<unknown>
  ) => {
    onRequestSort(event, property);
  };
  let headCells: HeadCell[] = [
    { id: 'customerAddress', label: 'آدرس' },
    { id: 'id', label: 'شناسه سفارش' },
    { id: 'sourceName', label: 'مرکز/انبار' },
    {
      id: 'partnerName',
      label: 'شرکت',
    },
    {
      id: 'deliveryDate',
      label: 'تاریخ تحویل',
    },
    {
      id: 'deliveryStartTime',
      label: 'ساعت تحویل',
    },
    {
      id: 'weight',
      label: 'وزن',
    },
    {
      id: 'length',
      label: 'ابعاد',
    },
    { id: 'status', label: 'وضعیت' },
  ];

  return (
    <TableHead>
      <TableRow>
        <StyledTableCell padding="checkbox">
          <Checkbox
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={props.onSelectAllClick}
            inputProps={{ 'aria-label': 'select all desserts' }}
            style={{ color: '#fff' }}
          />
        </StyledTableCell>
        {headCells.map(headCell => (
          <StyledTableCell
            key={headCell.id}
            align="center"
            sortDirection={orderBy === headCell.id ? order : false}
            data-cy={headCell.id}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
              classes={{
                // Override with the active class if this is the selected column or inactive otherwise
                icon:
                  orderBy === headCell.id
                    ? classes.activeSortIcon
                    : classes.inactiveSortIcon,
              }}
              IconComponent={() => (
                <Icon
                  path={
                    orderBy === headCell.id && order === 'desc'
                      ? mdiChevronDown
                      : mdiChevronUp
                  }
                  size={0.7}
                  className={
                    orderBy === headCell.id
                      ? classes.activeSortIcon
                      : classes.inactiveSortIcon
                  }
                />
              )}
            >
              <span className={classes.columnText}>{headCell.label}</span>
            </TableSortLabel>
          </StyledTableCell>
        ))}
        <StyledTableCell />
      </TableRow>
    </TableHead>
  );
}

export default function EnhancedTable(props: Props) {
  const authContext = useContext(AuthContext);
  const classes = useStyles();

  const [order, setOrder] = React.useState<Ord>('desc');
  const [orderBy, setOrderBy] = React.useState<keyof Data>('id');
  const [selected, setSelected] = React.useState<string[]>([]);

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: keyof Data
  ) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };
  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    props.handleSelectAllClick(event)
  };
  const HtmlTooltip = withStyles((theme: Theme) => ({
    tooltip: {
      backgroundColor: '#f5f5f9',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 220,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #dadde9',
    },
  }))(Tooltip);

  const handleClick = (order: any) => {
    props.handleSelectedItem(order)
  };

  const isSelected = order => {
    const list = props.selectedList.map(el => el.id)
    return list.indexOf(order.id) !== -1
  };

  return (
    <div className={classes.root}>
      <EnhancedTableToolbar
        handleSelectedList={props.handleSelectedList}
        numSelected={props.selectedList.length}
        selected={props.selectedList}
        data={props.data}
      />
      <Paper className={classes.paper}>
        <TableContainer className={classes.container}>
          <Table
            stickyHeader
            className={classes.table}
            aria-labelledby="tableTitle"
            size={checkMatchMedia('(max-width: 1024px)') ? 'small' : 'medium'}
            aria-label="enhanced table"
          >
            <EnhancedTableHead
              classes={classes}
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              rowCount={props.data.length}
              numSelected={props.selectedList.length}
              onSelectAllClick={handleSelectAllClick}
            />

            <TableBody>
              {stableSort(props.data, getComparator(order, orderBy))
                .slice()
                .map((row: any, index: number) => {
                  const labelId = `enhanced-table-checkbox-${index}`;
                  const isItemSelected = isSelected(row);
                  let color = '';
                  let backgroundColor = '';
                  switch (true) {
                    case row.status === 'UNLOADED' ||
                      row.status === 'PACKAGED' ||
                      row.status === 'BUNDLED' ||
                      row.status === 'ASSIGNED':
                      backgroundColor = '#d1e8fa';
                      color = '#283c74';
                      break;
                    case row.status === 'CANCELLED' ||
                      row.status === 'RETURNING':
                      backgroundColor = '#fdd1cc';
                      color = '#611a15';
                      break;
                    case row.status === 'LOADED' || row.status === 'DELIVERED':
                      backgroundColor = '#d7fcd7';
                      color = '#1e4659';
                      break;
                  }

                  return (
                    <TableRow
                      // onClick={(event) => handleClick(event, row.id)}
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      selected={isItemSelected}
                      key={index}
                      hover
                    >
                      <StyledTableCell padding="checkbox">
                        <Checkbox
                          key={index}
                          onClick={() =>
                            handleClick(
                              row,
                              row?.fulfillmentWarehouseId
                                ? row?.fulfillmentWarehouseId
                                : row?.centerId
                            )
                          }
                          checked={isItemSelected}
                          inputProps={{ 'aria-labelledby': labelId }}
                        />
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        style={{ color: color }}
                        data-cy="row-id"
                      >
                        <HtmlTooltip title={row?.customerAddress}>
                          <span>
                            {`${row.customerCity
                              }-${row?.customerAddress?.substring(0, 20)}`}
                          </span>
                        </HtmlTooltip>
                      </StyledTableCell>
                      <StyledTableCell
                        id={labelId}
                        scope="row"
                        align="center"
                        style={{ color: color }}
                      >
                        {row.id}
                      </StyledTableCell>
                      <StyledTableCell
                        id={labelId}
                        scope="row"
                        align="center"
                        style={{ color: color, direction: 'ltr' }}
                      >
                        {row?.fulfillmentWarehouseName
                          ? row?.fulfillmentWarehouseName
                          : row?.sourceName}
                      </StyledTableCell>
                      <StyledTableCell scope="row" align="center">
                        {row.partnerName}
                      </StyledTableCell>
                      <StyledTableCell align="center" style={{ color: color }}>
                        <span>
                          {jMoment(row.deliveryDate, 'YYYY/M/D')
                            .locale('fa')
                            .format('jYY/jMM/jDD')}
                        </span>
                      </StyledTableCell>
                      <StyledTableCell align="center" style={{ color: color }}>
                        <span>
                          {`${jMoment(row.deliveryStartTime, 'HH:mm:ss')
                            .locale('fa')
                            .format('HH:mm')}`}
                          {` - ${jMoment(row.deliveryEndTime, 'HH:mm:ss')
                            .locale('fa')
                            .format('HH:mm')}`}
                        </span>
                      </StyledTableCell>
                      <StyledTableCell
                        id={labelId}
                        scope="row"
                        align="center"
                        style={{ color: color }}
                      >
                        {row.weight}
                      </StyledTableCell>
                      <StyledTableCell
                        id={labelId}
                        scope="row"
                        align="center"
                        style={{ color: color, direction: 'ltr' }}
                      >
                        {row.length
                          ? `${row.length} x ${row.width} x ${row.height}`
                          : '-'}
                      </StyledTableCell>
                      <StyledTableCell scope="row" align="center">
                        {translate(row.status, 'order')}
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        <div>
                          <Link to={`/nonPost-orders/${row.id}`}>
                            <IconButton
                              aria-label="details"
                              size="small"
                              title="جزئیات سفارش"
                              data-cy="details"
                            >
                              <Icon
                                path={mdiFileDocumentOutline}
                                size={1}
                                color={theme.palette.green.main}
                              />
                            </IconButton>
                          </Link>
                          <Link to={`/orders/${row.id}/allLogs`}>
                            <IconButton size="small" title="تاریخچه سفارش">
                              <Icon path={mdiHistory} size={1} />
                            </IconButton>
                          </Link>
                        </div>
                      </StyledTableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </div>
  );
}
